var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.atividades),function(atvdd,index){return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(atvdd.nome),expression:"atvdd.nome"}],key:index,staticClass:"atividade-trilha"},[_c('img',{staticClass:"icones",staticStyle:{"width":"25px","height":"auto"},attrs:{"src":atvdd.icone}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }